import React from 'react';
import { useParams } from 'react-router-dom';
import { GitBranch } from 'lucide-react';

const WorkflowDetails: React.FC = () => {
  const { workflowId } = useParams<{ workflowId: string }>();

  return (
    <div className="space-y-6">
      <div className="text-center py-20">
        <GitBranch className="h-16 w-16 mx-auto text-gray-400 mb-4" />
        <h2 className="text-2xl font-bold text-gray-900 mb-2">Workflow {workflowId}</h2>
        <p className="text-gray-600">Workflow details page coming soon...</p>
      </div>
    </div>
  );
};

export default WorkflowDetails;
